import { render, staticRenderFns } from "./fourDetail.vue?vue&type=template&id=22206a86&scoped=true"
import script from "./fourDetail.vue?vue&type=script&lang=js"
export * from "./fourDetail.vue?vue&type=script&lang=js"
import style0 from "./fourDetail.vue?vue&type=style&index=0&id=22206a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22206a86",
  null
  
)

export default component.exports